import { Component, OnInit } from "@angular/core";
import { OutpostRemoteViewModel } from "./outpost-remote.view-model";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {OutpostRepository} from "../../../domain/outposts/outpost-repository";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: "evrideo-outpost-remote",
  templateUrl: "./outpost-remote.component.html",
  styleUrls: ["./outpost-remote.component.scss"],
})
export class OutpostRemoteComponent implements OnInit {
  vm: OutpostRemoteViewModel;
  activeItemId: string | null = null;
  iframeSrc: SafeResourceUrl | null = null;

  constructor(private outpostRepository: OutpostRepository,
              private sanitizer: DomSanitizer) {
    if (!OutpostRemoteViewModel.LastState) {
      OutpostRemoteViewModel.LastState = new OutpostRemoteViewModel();
    }
    this.vm = OutpostRemoteViewModel.LastState;
  }

  ngOnInit(): void {
    this.vm.OnInit();
  }

  onSidebarItemClick(event: { outpostId: string; isOnline: boolean }): void {
    if (!event.isOnline) {
      return;
    }

    const outpostId = event.outpostId;
    this.activeItemId = outpostId;
    this.iframeSrc = null;

    this.outpostRepository.startSession(outpostId).then((response) => {
      const fullUrl = environment.ENDPOINT + response.iframeUrl;
      this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
    }).catch((err) => {
      const message = err?.message ?? err?.error_description ?? "Failed to start remote session";
      this.iframeSrc = null;
    });
  }

  onIframeLoad(event: Event): void {
    const iframe = event.target as HTMLIFrameElement;

    try {
      const doc = iframe.contentDocument;
      if (!doc || !doc.documentElement) {
        console.warn('Remote iframe: contentDocument is null or has no documentElement');
        return;
      }

      const existing = doc.getElementById('remote-scale-style');
      if (existing) {
        existing.remove();
      }

      const style = doc.createElement('style');
      style.id = 'remote-scale-style';
      style.textContent = `
      html {
        transform: scale(0.5);
        transform-origin: 0 0;
        width: 200%;
        height: 200%;
        overflow: hidden;
      }
    `;

      // Prefer to inject into <head>; if it doesn't exist, fall back to the root element
      if (doc.head) {
        doc.head.appendChild(style);
      } else {
        doc.documentElement.insertBefore(style, doc.documentElement.firstChild);
      }

      console.log('Remote iframe: scale style injected');
    } catch (e) {
      console.warn('Remote iframe: failed to inject style', e);
    }
  }
}
